// Visibility logic for the "get the app" banner shown to logged-in users who
// open the web SPA in a phone/tablet browser. Pure functions so the rules are
// unit-testable; the SmartAppBanner component wires in the live environment.
//
// Deliberately NOT dismissible: the mobile browser version is unsupported
// (stability), so the banner stays up until the user switches to the app.
import { isMarketingPath } from '@/lib/route-gates'

export type MobileStoreOs = 'ios' | 'android'

export function detectMobileStoreOs(userAgent: string, maxTouchPoints: number): MobileStoreOs | null {
  if (/iPhone|iPad|iPod/i.test(userAgent)) return 'ios'
  // iPadOS ≥13 reports a desktop-Mac UA; touch support is the tell.
  if (/Macintosh/i.test(userAgent) && maxTouchPoints > 1) return 'ios'
  if (/Android/i.test(userAgent)) return 'android'
  return null
}

export interface AppBannerInput {
  isNativePlatform: boolean
  userAgent: string
  maxTouchPoints: number
  userRole: string | null
  pathname: string | null | undefined
  urls: Record<MobileStoreOs, string>
}

export function resolveAppBanner(input: AppBannerInput): { os: MobileStoreOs; url: string } | null {
  if (input.isNativePlatform) return null
  if (!input.userRole || input.userRole === 'CONTRACTOR') return null
  if (isMarketingPath(input.pathname)) return null
  const os = detectMobileStoreOs(input.userAgent, input.maxTouchPoints)
  if (!os) return null
  const url = input.urls[os]
  if (!url) return null
  return { os, url }
}
